import React from "react"

// components
// import { Typography } from "antd"

// configs
// import config from "config"

const Zusatzstoffe = () => (
  <div style={{ textAlign: "right", marginTop: 40 }}>
    {/* <Typography.Paragraph
      style={{ fontSize: 12, color: config.textColor }}
      type="secondary"
    >
      Zusatzstoffe:
      <br />
      1 = mit Farbstoffen; <br />
      2 = mit Konservierungsstoffen; <br />
      3 = mit Antioxidationsmittel; <br />
      4 = mit Geschmacksverstärker; <br />
      9 = Koffeinhaltig; <br />
      11 = mit Süßungsmittel;
    </Typography.Paragraph>

    <Typography.Paragraph
      style={{ fontSize: 12, color: config.textColor }}
      type="secondary"
    >
      Allergene:
      <br />
      A = glutenhaltiges Getreide; <br />
      B = Krebsfleischimitat; <br />
      C = Eier und Eiererzeugnisse; <br />
      D = Fisch und Fischeruegnisse; <br />
      E = Erdnüsse und Erdnusserzeugnisse;
      <br />
      F = Sojabohnen und Sojabohnenerzeugnisse; <br />
      G = enthält Milch und Milcherzeugnisse (Laktose); <br />
      L = Sesamsamen und Sesamerzeugnisse; <br />
      I = Sellerie; <br />O = Weichtiere;
    </Typography.Paragraph> */}
  </div>
)

export default Zusatzstoffe
